<div #plotlyContainer style="height:100%;">
<plotly-plot
    [data]="data"
    [layout]="layout"
    [useResizeHandler]="true"
    [style]="{position: 'relative', width: '100%', height: '100%'}">
</plotly-plot>
</div>
